
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/label-gallery",
      function () {
        return require("private-next-pages/label-gallery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/label-gallery"])
      });
    }
  